export enum RealtimeEvent {
  MACHINE_ADDED = 'MachineAdded',
  MACHINE_EDITED = 'MachineEdited',
  MACHINE_DELETED = 'MachineDeleted',
  EP_SAVED = 'EpSaved',
  PROCESSING_FAILED = 'EpProcessingFailed'
}
